export default __webpack_public_path__ + "static/media/over-axle-axlesGroup-size-weight.3e30dcc7.svg";